import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminMySites = lazy(() => import("@/pages/admin/AdminMySites"));

export const Route = createFileRoute("/admin/mina-sidor")({
  component: () => <AdminMySites />,
});
